// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/survey/question/responses" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { createTableFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createTableFetcherFunctionWithShadowError";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdSurveyQuestionResponses } from "./constants";
import type {
  EngagementAppGroupIdSurveyQuestionResponsesParams,
  EngagementAppGroupIdSurveyQuestionResponsesResult,
  EngagementAppGroupIdSurveyQuestionResponsesResultErrors,
} from "./types";
import { isEngagementAppGroupIdSurveyQuestionResponsesResult } from "./validators";

export const getDataTableEngagementAppGroupIdSurveyQuestionResponses = reactQueryTableFetcherAdapter(
  engagementAppGroupIdSurveyQuestionResponses,
  createTableFetcherFunctionWithShadowError<EngagementAppGroupIdSurveyQuestionResponsesResultErrors>()(
    (
      signal: AbortSignal,
      {
        appGroupId,
        questionId,
        query = {},
        groupby,
        limit = 20,
        start = 0,
        sortdir,
        sortby,
        landingPageId,
        campaignBaseId,
        messageVariationId,
        startDate,
        endDate,
      }: EngagementAppGroupIdSurveyQuestionResponsesParams
    ): Promise<EngagementAppGroupIdSurveyQuestionResponsesResult> => {
      return fetch(
        `/engagement/${appGroupId}/survey/question/responses`,
        "GET",
        {
          groupby,
          limit,
          sortby,
          sortdir,
          start,
          app_group_id: appGroupId,
          query: serializeQueryObjects(query),
          question_id: questionId,
          landing_page_id: landingPageId,
          campaign_base_id: campaignBaseId,
          message_variation_id: messageVariationId,
          start_date: startDate,
          end_date: endDate,
        },
        { signal }
      );
    }
  ),
  isEngagementAppGroupIdSurveyQuestionResponsesResult
);
